const getCustomerGuid = async (identityPromise) => {
  const identity = await identityPromise;

  const isRecognised = (await identity.customer.isRecognised?.()) || false;
  const isAuthenticated = await identity.customer.isAuthenticated();
  const customerGuid = await identity.customer.customerGuid();

  if (isRecognised || isAuthenticated) {
    return customerGuid;
  }

  return null;
};

export default getCustomerGuid;
